import { childActionTypes } from "../settings/types";

const initialState = {
    editMode            : false,
    showModal           : false,
    disableInputs       : false,
    saveSuccess         : false,
    resetCombos         : false,
    childObject         : {},
    // LIST REDUCERS
    filter              : null,
    listChildObjects    : null,
    pageSize            : 10,
    pageIndex           : 0,
    totalSize           : 0,
}

const subFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case childActionTypes.clearState:
            return initialState
        case childActionTypes.tableParams:
            return {
                ...state,
                pageSize: action.payload.pageSize,
                pageIndex: action.payload.pageIndex,
                totalSize: action.payload.totalSize
            }
        case childActionTypes.resetCombos:
            return {
                ...state,
                resetCombos: action.payload
            }
        case childActionTypes.filter:
            return {
                ...state,
                filter: action.payload
            }
        case childActionTypes.showModal:
            return {
                ...state,
                showModal: action.payload
            }
        case childActionTypes.childObject:
            return {
                ...state,
                childObject: action.payload
            }
        case childActionTypes.langs:
            return {
                ...state,
                childObject: {
                    ...state.childObject,
                    langs : action.payload
                }
            }
        case childActionTypes.formData:
            return {
                ...state,
                editMode: action.payload.editMode,
                disableInputs: action.payload.disableInputs,
                saveSuccess: action.payload.saveSuccess
            }
        case childActionTypes.listDomainObjects:
            return {
                ...state,
                listChildObjects: action.payload
            }
        case childActionTypes.addItem: {
            let resultList = []
            if (state.listChildObjects === null || state.listChildObjects.length === 0)
                resultList.unshift(action.payload)
            else {
                resultList = state.listChildObjects.slice()
                resultList.unshift(action.payload)
            }

            return { ...state, listChildObjects: resultList}
        }
        case childActionTypes.changeItem:{
            const resultList = state.listChildObjects.slice()
            const index = resultList.findIndex(i => i.id === action.payload.id);
            resultList[index] = action.payload
            return { ...state, listChildObjects: resultList}
        }
        case childActionTypes.removeItem: {
            const resultList = state.listChildObjects.filter( item => item.id !== action.payload)
            return { ...state, listChildObjects: resultList}
        }
        default:
            return state
    }
}

export default subFormReducer